var _CONFIG_MAP;

import QywxConfig from './qywx.config';
import WxConfig from './wx.config';
import DingTalkConfig from './dingtalk.config';
import FsConfig from './fs.config';
import { EcoType } from '../const/enums';
/** 新定义的生态，在此处插拔 */

var CONFIG_MAP = (_CONFIG_MAP = {}, _CONFIG_MAP[EcoType.dingTalk] = DingTalkConfig, _CONFIG_MAP[EcoType.fs] = FsConfig, _CONFIG_MAP[EcoType.qywx] = QywxConfig, _CONFIG_MAP[EcoType.wx] = WxConfig, _CONFIG_MAP);
/**
 * 根据指定生态，进行鉴权
 * @param {string} key
 * 从 /const/enums EcoType 中定义的类型匹配
 * @param {string} options {agentId}
 * agentId： 应用ID
 * @returns function
 * 协议调用，统一函数
 */

var ecoConfig = function ecoConfig(key, options) {
  var ConfigClass = CONFIG_MAP[key];
  if (!ConfigClass) return;
  var configInstanse = ConfigClass(options);
  return configInstanse;
};

export default ecoConfig;
export { EcoType, QywxConfig, WxConfig, DingTalkConfig, FsConfig };